import { SET_LANGUAGE } from "../constants/actions";

export function setLanguage(language){
  return {type: SET_LANGUAGE, language}
}


// WEBPACK FOOTER //
// ./src/actions/info.js